import { useState } from 'react';
import { validateConfirmPasswordError, validatePasswordError } from './utils';

export const useCreatePassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmError, setConfirmError] = useState('');

  const validate = (value: string) => {
    const error = validatePasswordError(value);
    setPasswordError(error);
    if (confirmPassword) {
      setConfirmError(validateConfirmPasswordError(confirmPassword, value));
    }
  };

  const onPasswordChange = (value: string) => {
    setPasswordError('');
    setPassword(value);
  };
  const onConfirmPasswordChange = (value: string) => {
    setConfirmError(validateConfirmPasswordError(value, password));
    setConfirmPassword(value);
  };

  const onPasswordBlur = (value: string) => {
    validate(value);
    setPassword(value);
  };
  return {
    password,
    passwordError,
    confirmError,
    confirmPassword,
    onPasswordChange,
    onPasswordBlur,
    updatePasswordError: setPasswordError,
    updateConfirmPasswordError: setConfirmError,
    onConfirmPasswordChange,
  };
};
